<template>
  <div id="modalEdit" tabindex="-1" @keyup.esc="$parent.recursoEdit=undefined">
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$i18n.t('edit')}}</h5>
            <button type="button" class="close" @click="$parent.recursoEdit=undefined">
              <span>&times;</span>
            </button>
          </div>

          <!-- ////////////////////////////////////////// IMAGENES O ARCHIVOS ////////////////////////////////////////////////////// -->

          <div class="modal-body" v-if="type=='file'">
            <!-- DIV FILE RECURSOS EDIT -->
            <div class="row">
              <div class="col-8" v-bind="file">
                <i
                  class="fas fa-file-video previewImagen2"
                  style="font-size:2.5em"
                  v-if="file.content_type && file.content_type.includes('video')"
                  @click="mostrarImagen(file._id,file.content_type,file.filename)"
                ></i>
                <img
                  v-if="file.content_type && file.content_type.includes('image')"
                  :src="url+'/resources/'+file._id"
                  class="previewImagen2"
                  @click="mostrarImagen(file._id,file.content_type,file.filename)"
                />
                <img
                  v-if="file.filename.toLowerCase().includes('.pdf')"
                  src="../img/pdf.png"
                  class="previewImagen2"
                  @click="mostrarImagen(file._id,file.content_type,file.filename)"
                  alt
                />
                <img
                  v-if="file.content_type && file.filename.toLowerCase().includes('.xls')||file.filename.toLowerCase().includes('.xlsx')||file.filename.toLowerCase().includes('.xlt')"
                  src="../img/xls.png"
                  class="previewImagen2"
                  @click="mostrarImagen(file._id,file.content_type,file.filename)"
                  alt
                />
                <audio
                  v-if="file.content_type && file.content_type.includes('audio')"
                  controls="controls"
                >
                  <source :src="url+'/resources/'+file._id" />
                </audio>
                <img v-if="noSoportado(file)" src="../img/noSoporte.png" class="previewImagen2" />
              </div>
              <div class="col-4" v-bind="file">
                <div>
                  <div>{{$i18n.t('modal.text')}}</div>
                  <input
                    v-model="order"
                    type="number"
                    min="0"
                    max="1000"
                    style="position: relative; top: 20px;"
                  />
                  <br />
                  <button
                    @click="editarRecurso(file._id)"
                    class="btn btn-primary"
                    style="position: relative; top: 40px;"
                  >{{$i18n.t('modal.btnOrder')}}</button>
                </div>
              </div>
            </div>
            <br />
            <!-- FIN DIV FILE RECURSOS EDIT -->
            <b>
              <label for="label">{{$i18n.t('modal.info')}}</label>
            </b>
            <br />
            <div class="d-flex flex-column" style="padding-left: 150px;">
              <div class="d-flex justify-content-start">
                <label>{{$i18n.t("previewArticulos.fileName")}}:</label>
                &nbsp;&nbsp;
                {{ file.filename }}
                <br />
              </div>
              <div class="d-flex justify-content-start">
                <label>{{$i18n.t("previewArticulos.uploadDate")}}:</label>
                &nbsp;&nbsp;
                {{ file.uploadDate }}
                <br />
              </div>
              <div class="d-flex justify-content-start">
                <label>{{$i18n.t('previewArticulos.size')}}:</label>
                &nbsp;&nbsp;
                {{calcTamanio(file.length)}}
                <br />
              </div>
              <!-- <div class="d-flex justify-content-start">
                <label>{{$i18n.t('modal.order')}}:</label>
                &nbsp;&nbsp;
                {{ file.orden }}
                <br />
              </div>-->
            </div>

            <vue-tags-input
              v-model="tag"
              :tags="tags"
              :autocomplete-items="filteredItems"
              :add-on-key="[13,' ', ',']"
              :autocomplete-min-length="3"
              @before-adding-tag="checkTag"
              @tags-changed="cambios"
              style="margin:0 auto"
            />
          
          
          </div>
          
          <!-- ////////////////////////////////////////// LINKS ////////////////////////////////////////////////////// -->

          <div class="modal-body" v-if="type=='link'">
            <select class="form-control" v-model="file.type">
              <option value="youtube">Youtube</option>
              <option value="facebook">Facebook</option>
              <option value="twitter">Twitter</option>
              <option value="vimeo">Vimeo</option>
              <option value="Otros">Otros</option>
            </select>
            <label for="label" style="margin-left:2%">Links:</label>
            <input type="text" class="form-control" v-model="file.name" />
            <br>

            <b-row >
              <b-col cols="6" sm="6" xs="6">

                <label for="label" style="margin-left:2%">Tags:</label>
                
                <vue-tags-input
                  v-model="tag"
                  :tags="tags"
                  :autocomplete-items="filteredItems"
                  :add-on-key="[13,' ', ',']"
                  :autocomplete-min-length="3"
                  @before-adding-tag="checkTag"
                  @tags-changed="cambios"
                  style="margin:0 auto"
                />
                
              </b-col>

              <b-col cols="6" sm="6" xs="6">

                <div>{{$i18n.t('modal.text_links')}}</div>
                  <input
                    v-model="order"
                    type="number"
                    min="0"
                    max="1000"
                    style="position: relative; top: 3px;"
                  />
              </b-col>

            </b-row>
            

          </div>

          <!-- ////////////////////////////////////////// BUCKET ////////////////////////////////////////////////////// -->

          <div class="modal-body" v-if="type=='bucket'">
            <label for="label" style="margin-left:2%">{{$i18n.t('contenedor.name')}}:</label>
            <input type="text" class="form-control" v-model="file.nombre" />
            <label for="label" style="margin-left:2%">{{$i18n.t('contenedor.note')}}:</label>
            <input type="text" class="form-control" v-model="file.nota" />
          </div>

          <!-- ////////////////////////////////////////// FOOTER ////////////////////////////////////////////////////// -->

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="guardarEdit">{{$i18n.t('save')}}</button>
            <button type="button" class="btn btn-danger" @click="$parent.recursoEdit = undefined">{{$i18n.t('close')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import notify from "devextreme/ui/notify";
// import ws from "../config.json";
import VueTagsInput from "@johmun/vue-tags-input";
// import previewArticulos from "../views/previewArticulos";
export default {
  name: "modalEdit",
  props: { file: Object, type: String },
  components: {
    VueTagsInput,
    // DxProgressBar
  },
  data() {
    return {
      tag: "",
      /*eslint no-useless-escape: "error"*/
      re: new RegExp(/^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/, "g"),
      etiquetas: [],
      tags: [],
      labels: [],
      componentKey: 0,
      url: this.$store.getters.ws.api_recursos,
      order: 0
    };
  },
  created() {
    this.axios.get(this.$store.getters.ws.api_recursos + "/labels", {
      params: {
        size: 1000
      }
    })
    .then(json => {
      this.etiquetas = json.data.content.map(p => p.nombre);
    });

    if (this.file && this.file.orden) {

      if (this.file.orden && this.file.orden.message) {
        this.orden = 0;
      } else {
        this.order = this.file.orden;
      }
    
    } else {
      this.order = 0;
    }

    if (this.file.labels && this.file.labels.length > 0) {
      
      this.file.labels.forEach(x => {
        this.tags.push({ text: x.nombre });
        this.labels.push(x.nombre);
      });
      if (this.labels.length > 0) {
        this.labels = this.labels.join(",")
      }
    
    }
  
  },
  computed: {
    filteredItems() {
      let filtro = this.etiquetas.filter(i => {
        return i.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
      let arrayObj = []
      if (filtro && filtro.length > 0) {
        for (let nombre of filtro) {
          arrayObj.push({ text: nombre })
        }
      }
      return arrayObj;
    },
    checkTagChange() {
      return this.tags;
    }
  },
  methods: {
    calcTamanio(size) {
      if (size > 999999) {
        return (size / 1000000).toFixed(2) + "MB";
      } else {
        return (size / 1000).toFixed(2) + "KB";
      }
    },
    async editarRecurso(idRecurso) {
      if (confirm(this.$i18n.t("modal.confirmOrder"))) {
        await this.axios
          .put(
            this.$store.getters.ws.api_recursos + "/utils/allResources?id=" + idRecurso + "&orden=" + this.order,
            {
              bucket_id: (this.file.bucket && this.file.bucket._id) ? this.file.bucket._id : null,
            }
          )
          .then(async e => {
            await this.$parent.obtenerRecursos();
            await this.$parent.obtenerInfoTituloVideo();
            
            this.$parent.recursoEdit = undefined;
            notify(
              this.$i18n.t("modal.orderUpdateSuc") + e.data.result.nModified + this.$i18n.t("modal.cont"), "success", 5000);
          })
          .catch(err => {
            notify(this.$i18n.t("modal.orderUpdateErr") + " - " + err, "warning", 5000) 
          });
      } else {
        return;
      }
    },
    mostrarImagen(id, cont, filename) {
      if (cont.includes("image") || cont.includes("video")) {
        this.imagen.id =
          this.$store.getters.ws.api_recursos + "/resources/" + id;
        this.imagen.type = cont;
      } else if (cont.includes("pdf")) {
        window.open(
          this.$store.getters.ws.api_recursos + "/resources/" + id,
          "_blank"
        );
      } else {
        this.axios
          .get(this.$store.getters.ws.api_recursos + "/resources/" + id, {
            responseType: "blob"
          })
          .then(response => {
            let link = document.createElement("a");
            let url = window.URL.createObjectURL(new Blob([response.data]));
            link.href = url;
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          });
      }
    },
    noSoportado(recurso) {
      if (
        recurso.filename &&
        recurso.content_type != null &&
        recurso.content_type
      )
        return !(
          recurso.filename.toLowerCase().includes(".xls") ||
          recurso.filename.toLowerCase().includes(".xlsx") ||
          recurso.filename.toLowerCase().includes(".xlt") ||
          recurso.filename.toLowerCase().includes(".pdf") ||
          recurso.content_type.includes("video") ||
          recurso.content_type.includes("image") ||
          recurso.content_type.includes("audio")
        );
      else return recurso.content_type == null;
    },
    async guardarEdit() {

      if (this.type == "file") {
        
        try {
          await this.axios
            .put(
              this.$store.getters.ws.api_recursos + "/resources/" +this.file._id,
              {
                bucket_id: (this.file.bucket && this.file.bucket._id) ? this.file.bucket._id : null,
                labels: this.labels,
                descripcion: this.file.descripcion
              }
            )
            .then(() => {
              notify(this.$i18n.t("modal.okEditLabels"), "success", 3000);
            });
          await this.$parent.obtenerRecursos();
          await this.$parent.obtenerInfoTituloVideo();
          this.$parent.recursoEdit = undefined;
        } catch (err) {
          notify(this.$i18n.t("error.ocurrio") + err.response.data.error);
        }
      
      } else {
        
        if (this.type == "link") {
          
          let linkvalid = this.validarLink(this.file.name);

          if (linkvalid) {
            
            try {

              await this.axios
              .put(this.$store.getters.ws.api_recursos + "/buckets/" + this.file.bucket_id + "/edit/" + this.file._id, {
                  link: {
                    _id: this.file._id,
                    name: linkvalid,
                    type: this.file.type,
                    labels: (this.labels && this.labels.length > 0) ? this.labels : "",
                    orden: this.order
                  }
                }
              )
              .then(() => {
                notify(this.$i18n.t("modal.okEditLink"), "success", 3000);
              });
              
              await this.$parent.obtenerLinks();
              this.$parent.recursoEdit = undefined;
            
            } catch (err) {
              notify(this.$i18n.t("error.ocurrio") + err.response.data.error);
            }
          
          }
        
        } else {

          if (this.type == "bucket") {
            try {
              this.$http
                .put(
                  this.$store.getters.ws.api_recursos + "/buckets/" + this.file._id,
                  this.file
                )
                .then(() => {
                  notify(this.$i18n.t("modal.okEditBuck"), "success", 3000);
                });
            } catch (err) {
              notify(this.$i18n.t("error.ocurrio") + err.response.data.error);
            }
          }
        
        }
      
      }
    
    },
    validarLink(link) {
      link = link.replace(/ /g, "");
      if (this.re.test(link)) {
        if (link.includes("https:")) {
          link = link.replace("https:", "");
        } else {
          link = link.replace("http:", "");
        }
        return link;
        /*eslint no-useless-escape: "error"*/
      } else {
        if (/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/.test(link)) {
          if (link) {
            if (link.substring(0,2) == "//") {
              link = `${link}`;
            } else {
              link = `//${link}`;
            }
          } else {
            link = `//${link}`;
          }
          return link;
        } else {
          notify(this.$i18n.t("modal.errorUrl"), "warning", 5000);
          return undefined;
        }
      }
    },
    cambios(array) {
      this.labels = array.map(p => p.text);
      let aux = "";
      this.labels.forEach(elem => {
        if (elem == this.labels[0]) {
          aux += elem;
        } else {
          aux += "," + elem;
        }
      });
      this.labels = aux;
    },
    checkTag(obj) {
      if (
        //toUpperCase y toLowerCase
        this.etiquetas.map(x => x.toLowerCase()).includes(obj.tag.text.toUpperCase()) ||
        this.etiquetas.map(x => x.toLowerCase()).includes(obj.tag.text.toLowerCase())
      ) {
        if (obj.tag.text.length > 3) {
          obj.addTag();
        }
      } else {
        if (obj.tag.text.length > 3) {
          let r = confirm(
            "Quiere agregar la etiqueta nueva " + obj.tag.text + " ?"
          );
          if (r) {
            this.axios
              .post(this.$store.getters.ws.api_recursos + "/labels", {
                nombre: obj.tag.text
              })
              .then(() => {
                notify(
                  "Se agrego la etiqueta " + obj.tag.text,
                  "success",
                  2000
                );
              });
            obj.addTag();
          }
        }
      }
    }
  }
};
</script>
<style>
.modal {
  display: block !important;
}

.previewImagen2 {
  /* height: 250px; */
  /* width: 400px; */
  max-width: 400px;
  max-height: 250px;
  cursor: pointer;
}
</style>